import {
  Button,
  CopyToClipboard,
  SpaceBetween, StatusIndicator,
} from "@amzn/awsui-components-react";
import {useContext, useState} from "react";
import {OrderIdContext, StageContext} from "../../contexes/OrderIdContext";
import {useExecuteRedrive} from "../redrive/hooks/useExecuteRedrive";

interface ActionButtonsProps {
  modalHandler: () => void;
  toggleAllSections: (expand: boolean) => void;
  inititalExpandedState?: boolean;
  copyConfig?: {
    textToCopy: string;
    buttonText: string;
    successText: string;
    errorText: string;
  };
  herdLink?: string;
  showRedrive: boolean;
}

enum RedriveStatus {
  NOT_STARTED = "NOT_STARTED",
  LOADING = "LOADING",
  SUCCESSFUL = "SUCCESSFUL",
  FAILED = "FAILED",
}

export function ActionButtons({
  modalHandler,
  toggleAllSections,
  inititalExpandedState,
  copyConfig,
  herdLink,
  showRedrive
}: ActionButtonsProps) {
  const orderId = useContext<string>(OrderIdContext);
  const stage = useContext<string>(StageContext);

  const [isExpanded, setIsExpanded] = useState(inititalExpandedState);
  const [redriveStatus, setRedriveStatus] = useState<RedriveStatus>(
    RedriveStatus.NOT_STARTED
  );

  const { executeSingleRedrive } = useExecuteRedrive()

  const handleRedriveOrder = async () => {
    if (!orderId || !stage) {
      setRedriveStatus(RedriveStatus.FAILED);
      return;
    }

    setRedriveStatus(RedriveStatus.LOADING);

    try {
      const { data } = await executeSingleRedrive(orderId, stage);
      const hasExecutionId = Boolean(data?.executionId);
      setRedriveStatus(
        hasExecutionId ? RedriveStatus.SUCCESSFUL : RedriveStatus.FAILED
      );
    } catch {
      setRedriveStatus(RedriveStatus.FAILED);
    }
  };

  const handleToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    toggleAllSections(newExpandedState);
  };

  return (
    <SpaceBetween direction="horizontal" size="xs">
      <Button onClick={modalHandler} iconName="command-prompt">
        View JSON
      </Button>
      <Button
        onClick={handleToggle}
        iconName={isExpanded ? "zoom-out" : "zoom-in"}
      >
        {isExpanded ? "Collapse All" : "Expand All"}
      </Button>
      {herdLink && (
        <Button
          href={herdLink}
          target="_blank"
          iconName="external"
        >
          View Herd
        </Button>
      )}
      {copyConfig && (
        <CopyToClipboard
          textToCopy={copyConfig.textToCopy}
          copyButtonText={copyConfig.buttonText}
          copySuccessText={copyConfig.successText}
          copyErrorText={copyConfig.errorText}
        />
      )}
      { showRedrive && (
        [RedriveStatus.SUCCESSFUL, RedriveStatus.FAILED].includes(redriveStatus)
        ? <StatusIndicator
            type={redriveStatus == RedriveStatus.SUCCESSFUL ? "success" : "error"}>Redrive Status: {redriveStatus}
          </StatusIndicator>
        : <Button disabled={redriveStatus === RedriveStatus.LOADING} iconName="refresh" onClick={handleRedriveOrder}>
            Redrive Order
          </Button>)
      }
    </SpaceBetween>
  );
}

ActionButtons.defaultProps = {
  inititalExpandedState: true,
};
